import LegalPageLayout from "@/components/legal/LegalPageLayout";
import { MapPin, Phone, Mail } from "lucide-react";

export default function Contact() {
  return (
    <LegalPageLayout title="Contact Us" testId="contact-page">
      <p>We'd love to hear from you - whether it's a question about a donation, a rescue, or giving from outside India.</p>

      <div className="grid gap-6 mt-8 not-prose">
        <div className="flex gap-4 items-start bg-white rounded-2xl border border-amtm-border p-5">
          <MapPin className="h-5 w-5 text-amtm-teal shrink-0 mt-0.5" />
          <div>
            <p className="font-semibold text-amtm-text mb-1">Registered Address</p>
            <p className="text-sm">
              Animal Matter To Me, Mumbai
              <br />
              CTS 166/167 Ashram, Madh Marve Road, Madh Jetti, Behind Manthara Residency,
              <br />
              Malad West, Village Erangal, Mumbai &ndash; 400061, Maharashtra, India
            </p>
          </div>
        </div>

        <div className="flex gap-4 items-start bg-white rounded-2xl border border-amtm-border p-5">
          <Phone className="h-5 w-5 text-amtm-teal shrink-0 mt-0.5" />
          <div>
            <p className="font-semibold text-amtm-text mb-1">Phone</p>
            <p className="text-sm" data-testid="contact-phone">
              <a href="tel:+919920737737" className="hover:text-amtm-teal">+91 9920 737 737</a>
            </p>
          </div>
        </div>

        <div className="flex gap-4 items-start bg-white rounded-2xl border border-amtm-border p-5">
          <Mail className="h-5 w-5 text-amtm-teal shrink-0 mt-0.5" />
          <div>
            <p className="font-semibold text-amtm-text mb-1">Email</p>
            <p className="text-sm" data-testid="contact-email">
              <a href="mailto:getinvolved@amtmindia.org" className="hover:text-amtm-teal">getinvolved@amtmindia.org</a>
            </p>
          </div>
        </div>
      </div>

      <h2 className="mt-10">Giving from outside India</h2>
      <p>
        By law, AMTM's foreign contributions may only be received into our designated FCRA bank account, so this
        Site accepts donations from Indian residents/citizens only. If you would like to give from outside India,
        please write to us at{" "}
        <a href="mailto:getinvolved@amtmindia.org">getinvolved@amtmindia.org</a> and our team will guide you through the
        FCRA-compliant process.
      </p>
    </LegalPageLayout>
  );
}
